// extracted by mini-css-extract-plugin
export default {"container":"PersonalProfile_container__5U16x","backButton":"PersonalProfile_backButton__g96Ie"};